import {
  analisarEnvolvimento,
  CONFIGURACAO_AVISOS_PADRAO,
  NOMES_ENVOLVIMENTO,
  TIPOS_ENVOLVIMENTO,
  tipoDoEnvolvimento,
  type ObjetoTabletop,
  type ParametrosTabletop,
} from '../../dominio/tabletop'

const inteiro = (valor: number) => String(Math.round(valor))

/**
 * O inspetor da ancoragem por envolvimento: o tipo (cesta, enforcado, três
 * voltas e duas pegadas), o ângulo entre as pernas e a carga em cada uma.
 */
export function InspetorEnvolvimento({
  objeto,
  aoAtualizarParametros,
}: {
  objeto: ObjetoTabletop
  aoAtualizarParametros?: (id: string, parametros: ParametrosTabletop) => void
}) {
  const a = analisarEnvolvimento(objeto)
  const limite = CONFIGURACAO_AVISOS_PADRAO.anguloMaximoAncoragemGraus
  return (
    <fieldset className="inspetor-vitima inspetor-corda">
      <legend>Ancoragem por envolvimento</legend>
      {aoAtualizarParametros && (
        <label className="campo">
          <span>tipo</span>
          <select
            value={tipoDoEnvolvimento(objeto)}
            aria-label="Tipo de envolvimento"
            onChange={(e) =>
              aoAtualizarParametros(objeto.id, {
                ...objeto.parametros,
                tipoEnvolvimento: TIPOS_ENVOLVIMENTO.indexOf(e.target.value as (typeof TIPOS_ENVOLVIMENTO)[number]),
              })
            }
          >
            {TIPOS_ENVOLVIMENTO.map((t) => (
              <option key={t} value={t}>
                {NOMES_ENVOLVIMENTO[t]}
              </option>
            ))}
          </select>
        </label>
      )}
      <p className="corda-resumo" role="status">
        {a.anguloEntrePernasGraus === null
          ? `${a.nome}: uma perna só, com 100% da carga.`
          : `${a.nome}: ${inteiro(a.anguloEntrePernasGraus)}° entre as pernas, cerca de ${inteiro(a.fracaoPorPerna * 100)}% da carga em cada uma.`}
      </p>
      {a.anguloEntrePernasGraus !== null && a.anguloEntrePernasGraus > limite && (
        <p className="aviso-corda" role="alert">
          O ângulo passa do limite de {inteiro(limite)}°: afaste o mosquetão do tronco (fita mais longa).
        </p>
      )}
      <p className="dica">{a.observacao}</p>
      <p className="dica">
        Ajuste o diâmetro do tronco e a distância até o mosquetão nos parâmetros abaixo. Prenda cordas e ancoragens no ponto "Mosquetão da
        fita". Cálculo didático: não vale como capacidade da fita nem do tronco.
      </p>
    </fieldset>
  )
}

/** Nas peças com tronco (árvore, poste, toco): o botão que põe uma fita em volta, já com o diâmetro do tronco. */
export function BotaoEnvolverComFita({ objeto, aoEnvolver }: { objeto: ObjetoTabletop; aoEnvolver: (id: string) => void }) {
  return (
    <div className="acoes-linha">
      <button type="button" className="btn-acao-cad btn-acao-cad--secundario" onClick={() => aoEnvolver(objeto.id)}>
        Envolver com fita
      </button>
      <span className="dica">Cria uma ancoragem por envolvimento em volta do tronco; gire para apontar o mosquetão.</span>
    </div>
  )
}
